import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulbOn } from '@fortawesome/pro-solid-svg-icons';

import './index.css';

function Tip(props) {
    return (
    	<div className='plan-tip'>
    	   <FontAwesomeIcon className="light" icon={faLightbulbOn} />
    	   {props.children}
    	</div>
    );
}

export default Tip;